import React, { useMemo } from 'react';
import { Modal } from 'antd';
import { X, ExternalLink } from 'lucide-react';

/**
 * SessionDocumentsDialog Component
 */
const SessionDocumentsDialog = ({ open, onClose, appointment }) => {
  // Process prescriptions into documents list (same logic as mobile app)
  const documents = useMemo(() => {
    if (!appointment?.prescriptions || appointment.prescriptions.length === 0) {
      return [];
    }

    const uniqueDocs = {};
    for (const item of appointment.prescriptions) {
      if (!uniqueDocs[item.prescriptionType]) {
        uniqueDocs[item.prescriptionType] = {
          label:
            item.prescriptionType === 'RECOMMENDATION'
              ? 'Recommendations'
              : item.prescriptionType === 'ASSESSMENT'
              ? 'Assessments'
              : item.prescriptionType === 'EXERCISE'
              ? 'Exercises'
              : item.prescriptionType,
          url: item.url,
        };
      }
    }

    return Object.values(uniqueDocs);
  }, [appointment]);

  const handleView = (url) => {
    window.open(url, '_blank');
  };

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      closeIcon={<X size={20} className="text-[#64748B]" />}
      width={500}
      centered
      className="session-documents-dialog"
    >
      <div className="p-6 font-poppins">
        {/* Header */}
        <div className="text-center mb-6">
          <h2 className="text-2xl font-bold text-[#4B61FF] mb-2">
            Session Documents
          </h2>
          <p className="text-sm text-[#64748B] font-medium mb-0">
            Access all your session records here.
          </p>
        </div>

        {/* Divider */}
        <div className="h-px bg-[#E2E8F0] mb-4"></div>

        {/* Documents List */}
        {documents.length > 0 ? (
          <div className="space-y-3">
            {documents.map((doc, index) => (
              <div
                key={index}
                className="flex items-center justify-between py-3 border-b-[1px] border-solid border-x-0 border-t-0 border-[#F1F5F9] last:border-b-0"
              >
                <span className="text-sm font-medium text-[#171717]">
                  {doc.label}
                </span>
                <button
                  onClick={() => handleView(doc.url)}
                  className="flex items-center gap-1 text-[#2563EB] font-poppins text-xs font-semibold bg-[#EFF6FF] hover:bg-[#DBEAFE] rounded-full px-3 py-1.5 border-0 transition-colors"
                >
                  View
                  <ExternalLink size={14} />
                </button>
              </div>
            ))}
          </div>
        ) : (
          <div className="py-8 text-center">
            <p className="text-sm font-medium text-[#64748B] italic">
              No documents attached to this appointment
            </p>
          </div>
        )}
      </div>
    </Modal>
  );
};

export default SessionDocumentsDialog;
